import { PROCESSING_PAYMENTS_DB_REF } from "../constants/firestore";
import { ProcessingPaymentState } from "../enums/processingPayments";
import { ProductWithPrice } from "../types/stripe";
import { firestoreDocDelete, firestoreDocRead, firestoreDocUpdate, firestoreWrite } from "./common/firebase";

export type ProcessingPayment = {
  uid: string;
  state: ProcessingPaymentState,
  tsStart: number;
  subscription: any;
}

export async function initNewProcessingPayment(
  uid: string,
  subscription: any,
): Promise<void> {
  const payload = _generateNewProcessingPaymentObj(uid, subscription)
  await firestoreWrite(PROCESSING_PAYMENTS_DB_REF, uid, payload);
}

// Per ora cancella il pagamento in pending e basta
export async function deleteProcessingPayment(
  uid: string
): Promise<void> {
  await firestoreDocDelete(PROCESSING_PAYMENTS_DB_REF, uid);
}

export async function checkProcessingPayment(
  uid: string
) {
  const pp = await firestoreDocRead(PROCESSING_PAYMENTS_DB_REF, uid);
  if (pp.exists()) {
    const startTs = (pp.data() as ProcessingPayment).tsStart;
    if ((Date.now() - startTs) > (60 * 10 * 1000)) {
      await firestoreDocUpdate(PROCESSING_PAYMENTS_DB_REF, uid, {state: ProcessingPaymentState.FAILED});
    }
  }
}

export async function retrieveAlreadyExistingProcessingPayment(
  uid: string
): Promise<ProcessingPayment | null> {
  const processingPaymentSnap = await firestoreDocRead(PROCESSING_PAYMENTS_DB_REF, uid);
  return processingPaymentSnap.exists() ? (processingPaymentSnap.data() as ProcessingPayment) : null;
}

function _generateNewProcessingPaymentObj(
  uid: string,
  subscription: any,
): ProcessingPayment {
  return {
    uid,
    state: ProcessingPaymentState.PENDING,
    subscription,
    tsStart: Date.now()
  }
}